import { createColumnHelper } from "@tanstack/react-table";

import {  useNavigate } from "react-router-dom";
import { Captin, listCaptinsRequest, listCaptinsResponse,  } from "../../../shared";

import { ShippsList } from "../components/shipps-list-card"
import { ENDPOINT_CONFIGS} from "../endpoints";
import { ApiError, callEndpoint } from "../fetch";
import { isAdmin, isLoggedIn } from "../fetch/auth";
import { ROUTES } from "../routes";

import { useEffect, useState } from "react";
import { Flex, Heading, Spinner, Stack } from "@chakra-ui/react";


export const ListCaptins =  () =>{
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [captins, setCaptins]= useState([] as Captin[]);
    const [busy, setBusy] = useState(true);
  

if (!isLoggedIn()) {
    navigate(ROUTES.SIGN_IN);
}

if (!isAdmin()) {
  navigate(ROUTES.HOME);
}



   useEffect(()=>{
  
  
    const fetchData = async()=>{
    try{
      const res= await callEndpoint<listCaptinsRequest, listCaptinsResponse>(ENDPOINT_CONFIGS.listCaptins);
     
        setCaptins(res.captins);
        setBusy(false);
      } catch (e) {
        setError((e as ApiError).message);
        setBusy(false);
      }
    }
    fetchData();
    
    },[])

   if(busy){
    return(
      <div>
         <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
        <Spinner></Spinner>
        </Flex>
      </div>
    )
  }
  
if (error){
return(

  <Flex minH={'100px'} margin={'auto'} align={'center'} justify={'center'} >
 {error}
 </Flex>
);}

  const columnHelper = createColumnHelper<Captin>();
  const columns = [
    columnHelper.accessor("id", {
      cell: (info: { getValue: () => any; }) => info.getValue(),
      header: "الرقم"
    }),
    columnHelper.accessor("email", {
      cell: (info: { getValue: () => any; }) => info.getValue(),
      header: "الإيميل"
    }),
    columnHelper.accessor("name", {
      cell: (info: { getValue: () => any; }) => info.getValue(),
      header: "الاسم"
    }),
  ];


   
      
   

  return (
   
    <div>
        <Flex padding={4} direction={'column'} dir={'rtl'}>
      <Stack align={'center'}>
            <Heading fontSize={'2xl'} textAlign={'center'} pb={4}>
             الكباتن 
            </Heading>
          </Stack>

      <ShippsList columns={columns} data={captins!}/>
      </Flex>
    </div>
  );
}